<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500px" content-class="restrict-portrait-mode">
      <v-card>
        <!-- <v-card-title class="headline">Use Google's location service?</v-card-title> -->
        <v-card-text class="text-center">
          <img src="/images/restrictLandscapeMode.png" alt />
          <h3
            class="text-white"
          >Please rotate your phone to landscape mode for better viewing experience</h3>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import "@/scss/_forceDowbloadMobileVersion.scss";
export default {
  data() {
    return {
      dialog: true
    };
  }
};
</script>
